import { call } from 'redux-saga/effects';
import { processPayloadAction } from './process_payload';

/**
 * Call processPayloadAction sequentially for each supplied apiAction
 * @param {Object} action - The action containing the apiActions to send
 */
export const processPayloadActions = function* (action) {
    for (const apiAction of action.actions) {
        yield call(processPayloadAction, apiAction);
    }
};
